import { SVGProps } from 'react';

export function Percent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={48}
      width={48}
      viewBox="0 0 48 48"
      className={`${props.className} fill-current`}
      {...props}
    >
      <path d="M14.5 21q-2.7 0-4.6-1.9Q8 17.2 8 14.5q0-2.7 1.9-4.6Q11.8 8 14.5 8q2.7 0 4.6 1.9 1.9 1.9 1.9 4.6 0 2.7-1.9 4.6-1.9 1.9-4.6 1.9Zm0-3q1.45 0 2.475-1.025Q18 15.95 18 14.5q0-1.45-1.025-2.475Q15.95 11 14.5 11q-1.45 0-2.475 1.025Q11 13.05 11 14.5q0 1.45 1.025 2.475Q13.05 18 14.5 18Zm19 22q-2.7 0-4.6-1.9-1.9-1.9-1.9-4.6 0-2.7 1.9-4.6 1.9-1.9 4.6-1.9 2.7 0 4.6 1.9 1.9 1.9 1.9 4.6 0 2.7-1.9 4.6-1.9 1.9-4.6 1.9Zm0-3q1.45 0 2.475-1.025Q37 34.95 37 33.5q0-1.45-1.025-2.475Q34.95 30 33.5 30q-1.45 0-2.475 1.025Q30 32.05 30 33.5q0 1.45 1.025 2.475Q32.05 37 33.5 37Zm-23.4 3L8 37.9 37.9 8l2.1 2.1Z" />
    </svg>
  );
}
